import * as React from 'react';
import { useParams } from 'react-router';
import { ArticlePageType } from '../../../utils/context/DeliveryContext';

import { useDeliveryContext } from '../../../utils/hooks/useDeliveryContext';
import { Seo } from '../../../utils/seo/Index';
import { FooterOverride } from '../../layout/FooterOverride';
import { Page } from '../../layout/Page';
import { Button } from '../../ui/button/Button';
import { ButtonGroup } from '../../ui/button/ButtonGroup';
import { ButtonGroupColumn } from '../../ui/button/ButtonGroupColumn';
import { Hero } from '../../ui/hero/Index';
import { Heading } from '../../ui/text/Heading';
import { ArticleContent } from './ArticleContent';
import { ArticleForm } from './ArticleForm';
import { ArticleIngress } from './ArticleIngress';
import { ArticleList } from './ArticleList';
import { ArticleQuote } from './ArticleQuote';
import { ArticleText } from './ArticleText';
import { ArticleTypeImage } from './ArticleTypeImage';
import { ArticleVideo } from './ArticleVideo';
import { DeliveryContainer } from './Container';

const Article: React.FC = () => {
  const params = useParams<{ slug: string }>();
  const { getArticle } = useDeliveryContext();
  const article = getArticle({ slug: params.slug });

  return (
    <Page>
      <Seo
        title={article?.seo?.title}
        description={article?.seo.description}
        image={article?.image}
      />
      {article?.video ? (
        <ArticleVideo video={article?.video} />
      ) : article?.image ? (
        <Hero
          imageUrl={article?.image}
          className="content-height flex padding-top-50"
          opacity={1}
          alt="bilde"
        ></Hero>
      ) : null}
      <ArticleContent>
        <DeliveryContainer>
          {article?.imageOverlay ? (
            <ArticleTypeImage
              src={article?.imageOverlay}
              alt="bilde-overlegg"
            />
          ) : null}
          <ButtonGroup style={{ margin: '2em 0 2em 0' }} className="center">
            <ButtonGroupColumn className="flex-center-mobile">
              <Button
                as="link"
                type="primary"
                colorTheme="gold"
                to={'/leveransebeskrivelse'}
              >
                Se alle episoder
              </Button>
            </ButtonGroupColumn>
            <ButtonGroupColumn className="flex-center-mobile">
              <Button
                as="link"
                type="primary"
                colorTheme="gold"
                to="/leveransebeskrivelse/fritid"
              >
                Fritidseiendom
              </Button>
            </ButtonGroupColumn>
          </ButtonGroup>
          <Heading tag="h1" center>
            {article?.title}
          </Heading>
          {article?.ingress ? (
            <ArticleIngress
              dangerouslySetInnerHTML={{ __html: article?.ingress }}
            />
          ) : null}
          {article?.quote ? <ArticleQuote quote={article?.quote} /> : null}
          {article?.content ? (
            <ArticleText
              dangerouslySetInnerHTML={{ __html: article?.content }}
            />
          ) : null}
          <ArticleList pagination />
          <ArticleForm />
        </DeliveryContainer>
      </ArticleContent>
      <FooterOverride />
    </Page>
  );
};

export default Article;
